export class Promotion {

    public id: number;
    public name: string;
    public description: string;
    public masterPromoText: string;
    public hostingCoupon: string;
    public hostingPromoText: string;
    public streamingCoupon: string;
    public streamingPromoText: string;
    public applicationsCoupon: string;
    public applicationsPromoText: string;
    public resellerHostingCoupon: string;
    public resellerHostingPromoText: string;
    public resellerStreamingCoupon: string;
    public resellerStreamingPromoText: string;
    public categoryOverridesMasterPromoText: boolean;

    public static emptyPromotion(): Promotion {
        return new Promotion(-1, '', '', '', '', '',
            '', '', '', '', '',
            '', '', '', false);
    }

    public getCategoriesSummary(): string {
        return (
            ((this.hostingCoupon && this.hostingCoupon.length > 0) ? 'Hosting' : '')
            + ((this.streamingCoupon && this.streamingCoupon.length > 0) ? ', Streaming' : '')
            + ((this.applicationsCoupon && this.applicationsCoupon.length > 0) ? ', Applications' : '')
            + ((this.resellerHostingCoupon && this.resellerHostingCoupon.length > 0) ? ', Reseller hosting' : '')
            + ((this.resellerStreamingCoupon && this.resellerStreamingCoupon.length > 0) ? ', Reseller streaming' : '')
        );
    }

    constructor(Id: number, Name: string, Description: string, MasterPromoText: string, HostingCoupon: string, HostingPromoText: string, StreamingCoupon: string, StreamingPromoText: string,
                ApplicationsCoupon: string, ApplicationsPromoText: string, ResellerHostingCoupon: string, ResellerHostingPromoText: string, ResellerStreamingCoupon: string, ResellerStreamingPromoText: string,
                CategoryOverridesMasterPromoText: boolean) {
        this.id = Id;
        this.name = Name;
        this.description = Description;
        this.masterPromoText = MasterPromoText;
        this.hostingCoupon = HostingCoupon;
        this.hostingPromoText = HostingPromoText;
        this.streamingCoupon = StreamingCoupon;
        this.streamingPromoText = StreamingPromoText;
        this.applicationsCoupon = ApplicationsCoupon;
        this.applicationsPromoText = ApplicationsPromoText;
        this.resellerHostingCoupon = ResellerHostingCoupon;
        this.resellerHostingPromoText = ResellerHostingPromoText;
        this.resellerStreamingCoupon = ResellerStreamingCoupon;
        this.resellerStreamingPromoText = ResellerStreamingPromoText;
        this.categoryOverridesMasterPromoText = CategoryOverridesMasterPromoText;
    }
}

